import type { QueryKey } from '@tanstack/react-query';
import type { GetMediaBlobParams } from '.';

export const get_media_blob_query_key = ({ media_id }: GetMediaBlobParams): QueryKey => ['get-media-blob', media_id];
